import { styled } from '@vw-marketing/us-components';

export const StyledInlineContainer: any = styled.div`
  ${({ background }) => `
    width: 100%;
    ${background ? `background:${background}` : ''}
`}
`;
